const responsiveCSSProperties = (theme) => {
    /**
     * generate responsive versions of a given CSS property
     * @example
     * myCard: {
     *   '&': theme.responsiveProperty('borderRadius', {'xs':'8px', 'lg':'16px'})
     * }
     *
     * @param {string} property - The CSS property to be made responsive
     * @param {(Object.<string, (string|number|function)>|string|number|function)} breakpointValues
     * - A dictionary of breakpoint keys and corresponding property values
     * - Alternatively, a single property value can be used for all sizes
     * @param {function} [mediaQueryGenerator=theme.breakpoints.up]
     * - Function that will be called using each key of {breakpointValues} to produce appropriate media query strings.
     * - Defaults to using theme.breakpoints.up
     * @returns {Object} responsive styles for {property}
     */
    const responsiveProperty = (property, breakpointValues, mediaQueryGenerator=theme.breakpoints.up) => {
        if (typeof breakpointValues !== 'object') return {[property]:breakpointValues};
        let obj = {};
        for (let key in breakpointValues) {
            obj[mediaQueryGenerator(key)] = {[property]:breakpointValues[key]};
        }
        return obj;
    }
    
    return {
        ...theme,
        responsiveProperty,
        // responsive property presets:
        borderRadius: {
            'xs':'8px',
            'sm':'12px',
            'md':'12px',
            'lg':'16px',
            'xl':'16px'
        },
    }
}

export default responsiveCSSProperties;